module.exports = __webpack_public_path__ + "static/media/apartment6.add15027.jpg";